import _ from 'lodash';
import store from "@/store";
import {i18n} from "@/main"

/**
 * Maps the status of a dispatch request to a human-readable value.
 * @param {string} status - The status of the dispatch request.
 * @param {string} dispatchTypeIdentifier - The dispatch type identifier, for context
 * @returns {string} The human-readable string.
 * @example dispatchRequestStatus('delivered') // => 'Afgeleverd'
 */
export const dispatchRequestStatus = (status, dispatchTypeIdentifier= undefined) => {
    const translationKey = `omt.gui.orders.dispatch-request-statuses.${status}_${dispatchTypeIdentifier}`
    let translation = i18n.t(translationKey)

    if (translation !== translationKey) {
        return translation
    }

    return i18n.t(`omt.gui.orders.dispatch-request-statuses.${status}`)
};

export const dispatcherTypes = () => {
    let dispatcherTypesToReturn = {}

    const typesSorted = _.chain(store.state.locationDataTypes.locationTypes)
        .sort((a, b) => {
            if (a.display_name > b.display_name) return 1
            if (a.display_name < b.display_name) return -1
            return 0
        })
        .value()

    typesSorted.forEach(type => {
        dispatcherTypesToReturn[type.identifier] = type.display_name
    })

    return dispatcherTypesToReturn
}

export const dispatcherType = (val) => {
    try {
        return store.state.locationDataTypes.locationTypes.find(d => d.identifier === val)
    } catch (e) {
        console.warn(e)
        return {
            identifier: val,
            display_name: val,
        }
    }
};

export default { dispatchRequestStatus, dispatcherTypes, dispatcherType };

export const dispatchTypesForSelectedDispatcher = (dispatchRequest) => {
    try {
        return _.sortBy(
            store.getters.getDispatchInfoForLocation( dispatchRequest.dispatcher_type, dispatchRequest.dispatcher_identifier)
                .filter(dispatchType => dispatchType.is_active && dispatchType.is_active_for_location),
            d => d.reroute_sort_order * -1
        )
    } catch (e) {
        console.error(e);
        return []
    }
}

export const carriersForSelectedDispatcherAndDispatchType = (dispatchRequest) => {
    try {
        return _.sortBy(
            dispatchTypesForSelectedDispatcher(dispatchRequest)
                .filter(type => type.id === dispatchRequest.dispatch_type_id || type.identifier === dispatchRequest.dispatch_type_identifier)
                [0]
                .carriers
                .filter(carrier => carrier.carrier_methods.some(carrierMethod => carrierMethod.is_active && carrierMethod.is_active_for_location))
            ,
            'display_name'
        )
    } catch (e) {
        console.error(e)
        return []
    }
}

export const carrierMethodsForSelectedCarrierAndDispatcherAndDispatchType = (dispatchRequest) => {
    try {
        return _.sortBy(
            carriersForSelectedDispatcherAndDispatchType(dispatchRequest)
                .find(c => c.identifier === dispatchRequest.carrier_identifier || c.id === dispatchRequest.carrier_method.carrier_id)
                .carrier_methods
                .filter(carrierMethod => carrierMethod.is_active && carrierMethod.is_active_for_location),
            'display_name'
        )
    } catch (e) {
        console.error(e)
        return []
    }
}
